import type { TradeInAemVehicleValuationType, TradeInAemVehicleValueResponseType } from "../../utils/types";

export const TRADE_IN_AEM_SET_VALUE_FETCHING = "tradeInAemVehicleValue/setValueFetching";
type TradeInAemSetValueFetch = {
    type: typeof TRADE_IN_AEM_SET_VALUE_FETCHING;
    fetching: boolean;
};
export const tradeInAenSetVehicleFetching = (fetching: boolean): TradeInAemSetValueFetch => ({
    type: TRADE_IN_AEM_SET_VALUE_FETCHING,
    fetching,
});

export const TRADE_IN_AEM_SET_QUOTE = "tradeInAemVehicleValue/setQuote";
type TradeInAemSetQuote = {
    type: typeof TRADE_IN_AEM_SET_QUOTE;
    quote: TradeInAemVehicleValuationType | null;
};
export const tradeInAemSetQuote = (quote: TradeInAemVehicleValuationType | null): TradeInAemSetQuote => ({
    type: TRADE_IN_AEM_SET_QUOTE,
    quote,
});

export const TRADE_IN_AEM_SET_QUOTE_FAILED = "tradeInAemVehicleValue/setFailed";
type TradeInAemSetQuoteFailed = {
    type: typeof TRADE_IN_AEM_SET_QUOTE_FAILED;
    failed: boolean;
};
export const tradeInAemSetQuoteFailed = (failed: boolean): TradeInAemSetQuoteFailed => ({
    type: TRADE_IN_AEM_SET_QUOTE_FAILED,
    failed,
});

export const TRADE_IN_AEM_SET_LATEST_RESPONSE = "tradeInAemVehicleValue/setLatestResponse";
type TradeInAemSetLatestResponse = {
    type: typeof TRADE_IN_AEM_SET_LATEST_RESPONSE;
    latestResponse: TradeInAemVehicleValueResponseType;
};
export const tradeInAemSetLatestResponse = (
    latestResponse: TradeInAemVehicleValueResponseType,
): TradeInAemSetLatestResponse => ({
    type: TRADE_IN_AEM_SET_LATEST_RESPONSE,
    latestResponse,
});
export const TRADE_IN_AEM_RESET_QUOTE = "tradeInAemVehicleValue/resetQuote";
type TradeInAemResetQuoteResponse = {
    type: typeof TRADE_IN_AEM_RESET_QUOTE;
};
export const tradeInAemResetQuote = (): TradeInAemResetQuoteResponse => ({
    type: TRADE_IN_AEM_RESET_QUOTE,
});

export type TradeInAemVehicleValueActions =
    | TradeInAemSetValueFetch
    | TradeInAemSetQuote
    | TradeInAemSetQuoteFailed
    | TradeInAemSetLatestResponse
    | TradeInAemResetQuoteResponse;
